import React from 'react';

import Summary from './Summary';

export default class ShopSummary extends React.Component {
  render() {
    return <Summary {...this.props} type="shop" initialCategory=",0," />;
  }
}
